module.exports = __webpack_public_path__ + "static/4-membership-benefit-66ccc14d902c089ed84d5d32c622bf78.png";